<template>
  <transition appear mode="out-in" @enter="onEnter" @leave="onLeave">
    <div v-if="motionKey !== 'empty'" :key="motionKey" class="modal-motion">
      <slot />
    </div>
  </transition>
</template>
<script lang="ts" setup>
// @ts-ignore

import { gsap } from 'gsap';
interface Props {
  motionKey: string | number;
  position?: 'center' | 'top-right';
}
defineProps({
  motionKey: null,
  position: { default: 'center' }
});

const { height: windowHeight } = useWindowSize();

const breakpoints = useEvaBreakpoints();

const isAboveL = breakpoints.greaterOrEqual('l');

const emit = defineEmits(["enter", "enterComplete", "leave", "leaveComplete"]);

const element = ref(null);

const onEnter = (el, done) => {
  element.value = el;
  const tl = gsap.timeline({
    onComplete: () => {
      emit('enterComplete');
      done();
    },
  });
  if (isAboveL.value) {
    tl.fromTo(
      element.value,
      { y: windowHeight.value },
      {
        y: 0,
        ease: 'elastic.out(1,0.8)',
        duration: 1,
      },
      0
    );
  } else {
    tl.fromTo(
      element.value,
      { y: windowHeight.value },
      {
        y: 0,
        ease: 'power4.out',
        duration: 0.5,
      },
      0
    );
  }

  emit('enter');
};

const onLeave = (el, done) => {
  const tl = gsap.timeline({
    onComplete: () => {
      emit('leaveComplete');
      done();
    },
  });

  tl.to(
    element.value,
    {
      y: windowHeight.value,
      ease: 'back.in',
      duration: 0.4,
    },
    0
  );

  emit('leave');
};
</script>
<style lang="scss" scoped>
.modal-motion {
  width: 100%;

  @include above('l') {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
</style>
